import { EffectCallback, useEffect } from 'react';

/**
 * One time hook with disabled dependencies.
 *
 * @param effect - effect callback, which should be run only once
 */
// eslint-disable-next-line react-hooks/exhaustive-deps
export const useComponentDidMount = (effect: EffectCallback) => useEffect(effect, []);
